import { Box } from '@mui/material';
import { PropsWithChildren, ReactElement } from 'react';
import { useIsMobile } from '@synergy/components-next';

export const EmptyStateContent = (props: PropsWithChildren): ReactElement => {
    const isMobile = useIsMobile();

    return (
        <Box typography="body1" sx={{ maxWidth: isMobile ? '295px' : '440px' }}>
            {props.children}
        </Box>
    );
};
